<template>
  <div class="admin">
    <el-container>
      <el-aside width="250px">
        <h1 class="admin_title">广州市金界电子管理系统</h1>
        <ul class="nav">
          <a v-for="item in nav" :key="item.name" :href="item.href" style="color:#fff;">
            <li>
              <i :class="item.icon" style="color:#fff;padding-right:5px;"></i>
              <span>{{item.name}}</span>
            </li>
          </a>
          <!-- <li v-for="(item,index) in nav" :key="item.name" v-on:click="change(index)">
            <i :class="item.icon" style="color:#fff;padding-right:5px;"></i>
            <a style="width:100%;" :href="item.href">{{item.name}}</a>
          </li>-->
        </ul>
      </el-aside>
      <el-container>
        <!-- <el-header>
          <h1>广州市纳星电子后台管理</h1>
        </el-header>-->
        <el-main>
          <router-view></router-view>
          <!-- <component :is="currentView"></component> -->
        </el-main>
        <el-footer>Footer</el-footer>
      </el-container>
    </el-container>
  </div>
</template>
<style scoped>
.el-header,
.el-footer {
  /* background-color: #b3c0d1; */
  color: #333;
  text-align: center;
  line-height: 60px;
}

.el-aside {
  background-color: rgb(84, 92, 100);
  color: #fff;
  height: 1000px;
  /* text-align: left; */
}

.el-main {
  background-color: #fff;
  color: #333;
  height: 100%;
  /* text-align: center; */
  /* height: 900px; */
}

body > .el-container {
  margin-bottom: 40px;
}

.el-container:nth-child(5) .el-aside,
.el-container:nth-child(6) .el-aside {
  line-height: 260px;
}

.el-container:nth-child(7) .el-aside {
  line-height: 320px;
}
.admin_title {
  margin: 20px 0px;
  text-align: center;
}
.nav {
  width: 100%;
  margin: 40px 0;
}
.nav li {
  width: 100%;
  height: 50px;
  line-height: 50px;
  padding-left: 50px;
  cursor: pointer;
  box-sizing: border-box;
}
.nav li a {
  color: #fff;
}
.nav li:hover {
  background-color: rgb(67, 74, 80);
}
</style>
<script>
// import PlansManage from "./plans_manage.vue";
// import ProductsManage from "./products_manage.vue";
// import UE from "./UE.vue";
export default {
  name: "admin",
  // components: {
  //   PlansManage,
  //   ProductsManage,
  //   UE
  // },
  data() {
    return {
      nav: [
        {
          icon: "el-icon-menu",
          name: "主页",
          href: ""
        },
        {
          icon: "el-icon-document",
          name: "方案管理",
          href: "/admin/planmanage"
        },
        {
          icon: "el-icon-goods",
          name: "产品管理",
          href: "/admin/productmanage"
        },
        {
          icon: "el-icon-picture-outline",
          name: "轮播图管理",
          href: "/admin/carousel"
        },
        {
          icon: "el-icon-edit",
          name: "关于金界",
          href: "/admin/aboutmanage"
        },
        {
          icon: "el-icon-phone-outline",
          name: "联系我们",
          href: "/admin/phonemanage"
        },
        {
          icon: "el-icon-news",
          name: "合作伙伴",
          href: "/admin/partnermanage"
        },
        {
          icon: "el-icon-edit-outline",
          name: "底部文字",
          href: "/admin/footmanage"
        }
      ]
      // index: 0,
      // arr: ["", "PlansManage", "ProductsManage"]
    };
  },
  // watch: {
  //   $route(to, from) {
  //     this.$$route.push(to.fullPath);
  //     console.log(to);
  //     console.log(from);
  //   }
  // },
  methods: {
    change(index) {
      // this.index = index;
    }
  },
  computed: {
    currentView() {
      // return this.arr[this.index];
    }
  },
  created() {
    this.$emit("public_header", false);
    this.$emit("public_nav", false);
    this.$emit("public_footer", false);
  }
};
</script>





// WEBPACK FOOTER //
// src/components/admin.vue